import React from 'react';
import DealPrice from '../../../DealPrice.react';
import Config from 'arbitrip-common/client/utils/Config';
import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getPriceDebugTooltipContent } from 'arbitrip-common/client/utils/PointsUtils';

export const ElalPriceToChargeInfoBlock = ({
    t,
    hasDifferentDisplayCurrency,
    profile,
    DEAL,
    agent_pricing_props,
    contractClientCompanyId,
    applied_points_discount_value,
    nights,
    pricePerNight,
    active_agent_pricing,
    client_price_total,
    absolute_margin_total,
    points,
    maxPointsForDeal,
    user_chosen_points,
    points_to_display,
    points_display_string,
    TOTAL_PRICE,
    isBnplSelected = false,
    bnplUsdAmount = null,
    payNowUsdAmount = null,
}) => {
    return (
        <div className={`total-price-wrap elal${hasDifferentDisplayCurrency ? ' price-converted-wrap' : ''}`}>
            <span className="title">{t('DealDetails.Total')}</span>
            {profile.agent ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <DealPrice
                        displayTotalPrice={false}
                        supplier={DEAL.supplier_name}
                        currency={DEAL.currency}
                        price={DEAL.totalPrice}
                        totalPrice={DEAL.totalPrice}
                        netPrice={DEAL.net_price_total}
                        commission={DEAL.commission_total}
                        dealId={DEAL.id}
                        profile={profile}
                        reservationMode={true}
                        {...agent_pricing_props}
                        contractClientCompanyId={contractClientCompanyId}
                    />
                    {Config.dev_mode && (
                        <Tooltip
                            title={getPriceDebugTooltipContent(
                                DEAL,
                                profile,
                                applied_points_discount_value,
                                nights,
                                pricePerNight,
                                active_agent_pricing,
                                client_price_total,
                                absolute_margin_total,
                                points,
                                maxPointsForDeal,
                                user_chosen_points,
                                points_to_display,
                            )}
                            placement="top"
                            arrow
                        >
                            <InfoOutlinedIcon style={{ fontSize: '14px', cursor: 'help', color: '#666' }} />
                        </Tooltip>
                    )}
                </div>
            ) : (
                <React.Fragment>
                    <div className="flex" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <div className="sum" data-testid="elal-price-after-points">
                            {points_display_string && <>{points_display_string} +{' '}</>}
                            {(hasDifferentDisplayCurrency || isBnplSelected || payNowUsdAmount != null) && (
                                <>
                                    <div className="approx">*</div>{' '}
                                </>
                            )}
                            {isBnplSelected && bnplUsdAmount != null
                                ? `$${bnplUsdAmount}`
                                : payNowUsdAmount != null
                                  ? `$${payNowUsdAmount}`
                                  : TOTAL_PRICE}
                        </div>
                        {Config.dev_mode && (
                            <Tooltip
                                title={getPriceDebugTooltipContent(
                                    DEAL,
                                    profile,
                                    applied_points_discount_value,
                                    nights,
                                    pricePerNight,
                                    active_agent_pricing,
                                    client_price_total,
                                    absolute_margin_total,
                                )}
                                placement="top"
                                arrow
                            >
                                <InfoOutlinedIcon style={{ fontSize: '14px', cursor: 'help', color: '#666' }} />
                            </Tooltip>
                        )}
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};
